import React from "react";
import { useSetFirmwarePublished } from "@/hooks/useFirmwareReleases";

export function PublishToggle({
  releaseId,
  isPublished,
}: {
  releaseId: string;
  isPublished: boolean;
}) {
  const { mutate, isPending } = useSetFirmwarePublished();
  return (
    <button
      disabled={isPending}
      onClick={() => mutate({ releaseId, isPublished: !isPublished })}
      className={`text-xs px-sm py-xs rounded-md font-medium ${
        isPublished
          ? "bg-success-bg text-success-text hover:bg-success-bg/80"
          : "bg-warning-bg text-warning-text hover:bg-warning-bg/80"
      }`}
    >
      {isPublished ? "Published — click to unpublish" : "Unpublished — click to publish"}
    </button>
  );
}
